function TermsAndConditions() {
  return (
    <div className="terms container">
      <h1>Terms and Conditions</h1>

      <p>
        Welcome to the wacky world of the Rubber Ducky Blog! This website is
        brought to you by Rubber Ducky Inc., the official home of all things
        rubber ducky. Before you dive in, please take a moment to review the
        following terms and conditions that govern your use of the site.
      </p>

      <ol>
        <li>
          No actual rubber ducks will be harmed in the creation of this blog.
        </li>
        <li>
          Any opinions expressed by rubber ducks are purely coincidental and
          should not be taken seriously.
        </li>
        <li>
          All posts must be approved by the Chief Ducky Officer (CDO) before
          they are published.
        </li>
        <li>
          The CDO reserves the right to refuse any post that contains negativity
          towards rubber ducks.
        </li>
        <li>
          Any attempts to steal rubber ducks or their ideas will result in a
          lifetime ban from the blog.
        </li>
        <li>
          The blog is not responsible for any sudden urges to buy rubber ducks
          as a result of reading the posts.
        </li>
        <li>
          By accessing the blog, you agree to be constantly amazed by the
          intelligence and cuteness of rubber ducks.
        </li>
        <li>All disputes will be settled by a panel of expert rubber ducks.</li>
        <li>
          In the unlikely event that the world ends, the blog will become the
          property of the rubber ducks.
        </li>
      </ol>

      <p>
        By using the Rubber Ducky Blog, you agree to be bound by the terms of
        this Agreement, which may be updated from time to time. If you don't
        agree to these terms, we suggest finding another website to quack about
        on.
      </p>

      <p>
        The contents of the Rubber Ducky Blog are protected by copyright, but we
        promise not to get too serious about it. Just don't go around copying
        and pasting our stuff without our permission, or we'll send the Chief
        Ducky Officer (CDO) after you.
      </p>

      <p>
        The Rubber Ducky Blog may contain links to other websites, but we're not
        responsible for their content, no matter how offensive, inaccurate, or
        quacky it may be. If you're easily offended, proceed with caution.
      </p>

      <p>
        We make no warranties, guarantees, or promises about the Rubber Ducky
        Blog, but we promise to do our best to make it an enjoyable and
        entertaining experience.
      </p>

      <p>
        We reserve the right to change these terms and conditions whenever we
        feel like it, so be sure to check back often.
      </p>

      <p>
        By using the Rubber Ducky Blog, you agree to quack with us, warts and
        all. If you don't agree, it's time to find a different pond to swim in.
      </p>

      <p>
        This Agreement shall be governed by the laws of the United States, but
        let's be honest, rubber ducks run the show here.
      </p>

      <p>Enjoy the blog!</p>
    </div>
  );
}

export default TermsAndConditions;
